import { Alert } from '@material-ui/lab';
import React, { ReactElement, useState } from 'react';
import { useApiRequest } from 'src/hooks/useApi';
import { useAppToolchain } from 'src/hooks/useAppToolchain';
import Grid from '@material-ui/core/Grid';

import { Typography, Box, Switch, SwitchLabel, BDSProvider } from '@barracuda-internal/bds-core-v2';

function RequestPIConsent(): ReactElement {
	const [consent, setConsent] = useState(false);
	const [doConsent, setDoConsent] = useState(false);
	const [first, setFirst] = useState(false);
	const { api } = useAppToolchain();

	const [updateStatus, req, error] = useApiRequest(
		doConsent &&
			(() =>
				api.updateUserConfig('current', [
					{
						path: '/personalInfoCollectionConsented',
						op: 'replace',
						value: consent,
					},
				])),
		[doConsent],
		() => {
			setDoConsent(false);
		},
	);

	useApiRequest(
		(signal) => api.getLoggedInUser({ signal }),
		[first],
		(resp) => {
			const user = resp[1];
			setConsent(user.config.personalInfoCollectionConsented);
		},
	);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
		setConsent(checked);
		setDoConsent(true);
	};

	return (
		<BDSProvider>
		<Box>
			<Typography
				variant="h3"
				color="textPrimary"
				sx={{ mb: 4 }}
			>
				Personal Information Consent
			</Typography>
			{error ? (
				<Alert color="error">
					There was an error saving the form. Please try again.
				</Alert>
			) : null}
			<Box sx={{ ml: 2, mt: 2 }}>
				<Typography
					variant="h4"
					color="textPrimary"
					sx={{ mb: 2 }}
				>
					Consent confirmation
				</Typography>
				<Grid container spacing={1} style={{ marginTop: '16px', marginBottom: '16px', marginLeft: '8px' }}>
					<Grid item xs={3}>
						<SwitchLabel
							sx={{ gap: 1 }}
							control={
								<Switch
									name="checkedB"
									color="primary"
									onChange={handleChange}
									checked={consent}
									size="small"
								/>
							}
							label="Accepted"
						/>
					</Grid>
					<Grid item xs={9}>
					<Typography
							variant="body1"
							color="textPrimary"
							sx={{ mb: 2 }}
						>
							Barracuda Data Inspector can collect your name and
							email address for the purpose of providing product
							support and communicating product news and
							announcements. Please see our{' '}
							<a
								href="https://www.barracuda.com/company/legal/trust-center/data-privacy"
								target="_blank"
								rel="noreferrer"
							>
								Trust Center
							</a>{' '}
							for information on how we keep your data secure.
						</Typography>
					</Grid>
				</Grid>
			</Box>
		</Box>
		</BDSProvider>
	);
}

export default RequestPIConsent;
